'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);

var _excluded = ["children", "link", "target"];
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function L(_ref) {
  var _props$href, _props$href$match, _link$match;

  var children = _ref.children,
      link = _ref.link,
      target = _ref.target,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  if ((_props$href = props.href) === null || _props$href === void 0 ? void 0 : (_props$href$match = _props$href.match) === null || _props$href$match === void 0 ? void 0 : _props$href$match.call(_props$href, /^(https?:\/\/|mailto:|tel:)/gi)) {
    return /*#__PURE__*/React__default.cloneElement(children, _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, props), children.props));
  }

  if (!link || link === '#') {
    return null;
  }

  var linkString = (link === null || link === void 0 ? void 0 : (_link$match = link.match) === null || _link$match === void 0 ? void 0 : _link$match.call(link, /^(https?:\/\/|mailto:|tel:)/gi)) || (link === null || link === void 0 ? void 0 : link.startsWith('/')) || !(link === null || link === void 0 ? void 0 : link.startsWith('/')) && (link === null || link === void 0 ? void 0 : link.startsWith('https://')) ? link : "https://".concat(link);
  return /*#__PURE__*/React__default.createElement("a", _rollupPluginBabelHelpers.extends({
    href: linkString,
    target: target,
    rel: "noreferrer"
  }, props), children);
}

module.exports = L;
